module.exports = __webpack_public_path__ + "static/element-fd9d8ae4c7261ee1371406b95e64a3e3.svg";